<!-- Outermost Container for LIFF Mobile Responsive Page -->
<div class="overflow-y-auto w-full h-full pb-20 bg-slate-50 dark:bg-slate-900 custom-scrollbar">

  <!-- ================= Header Section ================= -->
  <div
    class="relative bg-(--background-color) text-slate-900 shadow-md rounded-b-[2rem] px-4 pt-6 pb-6 overflow-hidden">
    <!-- Background Glow & Pattern -->
    <!-- <div class="absolute -right-8 -top-8 w-36 h-36 bg-white/20 rounded-full blur-xl pointer-events-none"></div>
    <div class="absolute -left-8 -bottom-8 w-32 h-32 bg-amber-600/10 rounded-full blur-lg pointer-events-none"></div> -->

    <div class="relative z-10 flex items-center justify-between mb-3">
      <!-- Back Button (SVG Icon) -->
      <button (click)="goback()"
        class="w-10 h-10 bg-white/90 hover:bg-white text-slate-800 shadow-md rounded-full flex justify-center items-center active:scale-95 transition-all duration-200"
        aria-label="Back">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-slate-800" fill="none" viewBox="0 0 24 24"
          stroke="currentColor" stroke-width="2.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
        </svg>
      </button>

      <!-- Page Title -->
      <div class="text-center flex-1 mx-2">
        <h1 class="text-xl font-bold tracking-tight text-amber-500 flex items-center justify-center gap-1.5">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-amber-500" fill="none" viewBox="0 0 24 24"
            stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>
          <span>{{ currentLang === "TH" ? "ประวัติการชาร์จ EV" : "EV Charging History" }}</span>
        </h1>
        <p class="text-xs font-medium text-white">
          {{ currentLang === "TH" ? "ข้อมูลและสถิติย้อนหลังการชาร์จรถไฟฟ้า" : "Your EV charging logs & usage summary" }}
        </p>
      </div>

      <!-- Spacer for symmetry -->
      <div class="w-10"></div>
    </div>
  </div>

  <!-- ================= KPI Summary Stats Section ================= -->
  <div class="px-4 -mt-4 relative z-20">
    <div class="grid grid-cols-2 gap-2.5">

      <!-- Total Cost Stat -->
      <div
        class="bg-white dark:bg-slate-800/95 backdrop-blur-sm rounded-2xl p-3 shadow-md border border-slate-100 dark:border-slate-700/60 flex items-center gap-3 animate-fade-in-up delay-1">
        <div
          class="w-10 h-10 rounded-xl bg-amber-100 dark:bg-amber-900/40 text-amber-600 dark:text-amber-400 flex justify-center items-center flex-shrink-0 shadow-inner">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"
            stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V6m0 12v-2m0 0c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <div class="overflow-hidden">
          <p class="text-[11px] font-medium text-slate-400 dark:text-slate-400 truncate">
            {{ currentLang === "TH" ? "รวมค่าบริการ" : "Total Cost" }}
          </p>
          <p class="text-sm font-bold text-slate-800 dark:text-slate-100 truncate">
            {{ totalAmount | number:'1.2-2' }} <span class="text-xs font-normal text-slate-500">{{ currentLang === "TH"
              ? "บาท" : "THB" }}</span>
          </p>
        </div>
      </div>

      <!-- Total Energy Stat -->
      <div
        class="bg-white dark:bg-slate-800/95 backdrop-blur-sm rounded-2xl p-3 shadow-md border border-slate-100 dark:border-slate-700/60 flex items-center gap-3 animate-fade-in-up delay-2">
        <div
          class="w-10 h-10 rounded-xl bg-emerald-100 dark:bg-emerald-900/40 text-emerald-600 dark:text-emerald-400 flex justify-center items-center flex-shrink-0 shadow-inner">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"
            stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>
        </div>
        <div class="overflow-hidden">
          <p class="text-[11px] font-medium text-slate-400 dark:text-slate-400 truncate">
            {{ currentLang === "TH" ? "กระแสไฟฟ้ารวม" : "Total Energy" }}
          </p>
          <p class="text-sm font-bold text-slate-800 dark:text-slate-100 truncate">
            {{ totalKwh | number:'1.1-2' }} <span class="text-xs font-normal text-slate-500">kWh</span>
          </p>
        </div>
      </div>

      <!-- Total Sessions Stat -->
      <div
        class="bg-white dark:bg-slate-800/95 backdrop-blur-sm rounded-2xl p-3 shadow-md border border-slate-100 dark:border-slate-700/60 flex items-center gap-3 animate-fade-in-up delay-3">
        <div
          class="w-10 h-10 rounded-xl bg-blue-100 dark:bg-blue-900/40 text-blue-600 dark:text-blue-400 flex justify-center items-center flex-shrink-0 shadow-inner">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"
            stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <div class="overflow-hidden">
          <p class="text-[11px] font-medium text-slate-400 dark:text-slate-400 truncate">
            {{ currentLang === "TH" ? "จำนวนการชาร์จ" : "Sessions" }}
          </p>
          <p class="text-sm font-bold text-slate-800 dark:text-slate-100 truncate">
            {{ totalSessions }} <span class="text-xs font-normal text-slate-500">{{ currentLang === "TH" ? "ครั้ง" :
              "times" }}</span>
          </p>
        </div>
      </div>

      <!-- Total Duration Stat -->
      <div
        class="bg-white dark:bg-slate-800/95 backdrop-blur-sm rounded-2xl p-3 shadow-md border border-slate-100 dark:border-slate-700/60 flex items-center gap-3 animate-fade-in-up delay-4">
        <div
          class="w-10 h-10 rounded-xl bg-purple-100 dark:bg-purple-900/40 text-purple-600 dark:text-purple-400 flex justify-center items-center flex-shrink-0 shadow-inner">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"
            stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <div class="overflow-hidden">
          <p class="text-[11px] font-medium text-slate-400 dark:text-slate-400 truncate">
            {{ currentLang === "TH" ? "เวลารวม" : "Total Time" }}
          </p>
          <p class="text-sm font-bold text-slate-800 dark:text-slate-100 truncate">
            {{ formatDuration(totalDurationMinutes) }}
          </p>
        </div>
      </div>

    </div>
  </div>

  <!-- ================= Controls Section (Search & Filter Tabs) ================= -->
  <div class="px-4 mt-4 space-y-3">

    <!-- Search Input Field -->
    <div class="relative flex items-center">
      <div class="absolute left-3.5 pointer-events-none text-slate-400">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"
          stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
      </div>

      <input type="text" [(ngModel)]="searchTerm"
        [placeholder]="currentLang === 'TH' ? 'ค้นหาทะเบียน, สถานที่ หรือช่องชาร์จ...' : 'Search plate, location, slot...'"
        class="w-full pl-10 pr-9 py-2.5 text-sm bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-amber-400 focus:border-amber-400 transition-all text-slate-800 dark:text-slate-100 placeholder-slate-400" />

      <!-- Clear Search Button -->
      <button *ngIf="searchTerm" (click)="clearSearch()"
        class="absolute right-3 text-slate-400 hover:text-slate-600 p-1 active:scale-95 transition-transform"
        aria-label="Clear Search">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"
          stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Filter Segment Pills & Sort Button (Custom UI Controls) -->
    <div class="flex items-center justify-between gap-2 overflow-x-auto custom-scrollbar pb-1">

      <!-- Custom Segment Tabs (NO native select) -->
      <div class="flex items-center bg-slate-200/70 dark:bg-slate-800 p-1 rounded-xl gap-1 text-xs">
        <button (click)="setFilter('ALL')"
          [ngClass]="selectedFilter === 'ALL' ? 'bg-amber-400 text-slate-900 font-semibold shadow-sm' : 'text-slate-600 dark:text-slate-400 hover:text-slate-900'"
          class="px-3 py-1.5 rounded-lg transition-all active:scale-95 whitespace-nowrap">
          {{ currentLang === "TH" ? "ทั้งหมด" : "All" }}
        </button>

        <button (click)="setFilter('7DAYS')"
          [ngClass]="selectedFilter === '7DAYS' ? 'bg-amber-400 text-slate-900 font-semibold shadow-sm' : 'text-slate-600 dark:text-slate-400 hover:text-slate-900'"
          class="px-3 py-1.5 rounded-lg transition-all active:scale-95 whitespace-nowrap">
          {{ currentLang === "TH" ? "7 วันล่าสุด" : "Last 7 Days" }}
        </button>

        <button (click)="setFilter('30DAYS')"
          [ngClass]="selectedFilter === '30DAYS' ? 'bg-amber-400 text-slate-900 font-semibold shadow-sm' : 'text-slate-600 dark:text-slate-400 hover:text-slate-900'"
          class="px-3 py-1.5 rounded-lg transition-all active:scale-95 whitespace-nowrap">
          {{ currentLang === "TH" ? "30 วันล่าสุด" : "Last 30 Days" }}
        </button>
      </div>

      <!-- Sort Toggle Button -->
      <button (click)="toggleSort()"
        class="flex items-center gap-1.5 px-3 py-1.5 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-slate-700 dark:text-slate-300 rounded-xl text-xs font-medium shadow-sm active:scale-95 transition-all hover:bg-slate-50 flex-shrink-0">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5 text-amber-500 transition-transform duration-300"
          [ngClass]="{'rotate-180': sortDirection === 'ASC'}" fill="none" viewBox="0 0 24 24" stroke="currentColor"
          stroke-width="2.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12" />
        </svg>
        <span>{{ sortDirection === 'DESC' ? (currentLang === 'TH' ? 'ล่าสุด' : 'Newest') : (currentLang === 'TH' ?
          'เก่าสุด' : 'Oldest') }}</span>
      </button>

    </div>

  </div>

  <!-- ================= History Cards List Section ================= -->
  <div class="px-4 mt-3 space-y-3">

    <!-- Card Item Loop -->
    <div *ngFor="let evCharger of filteredEvChargerHistory; let i = index" (click)="openDetail(evCharger)"
      class="bg-white dark:bg-slate-800 rounded-2xl p-4 shadow-sm hover:shadow-md border border-slate-100 dark:border-slate-700/70 transition-all duration-200 transform active:scale-[0.99] cursor-pointer animate-fade-in-up space-y-3"
      [ngClass]="'delay-' + ((i % 5) + 1)">

      <!-- Card Top Header: Station Name & Date -->
      <div class="flex items-start justify-between gap-2 border-b border-slate-100 dark:border-slate-700/50 pb-2.5">
        <div class="flex items-center gap-2.5 min-w-0">
          <!-- Station Logo / Icon -->
          <div
            class="w-9 h-9 rounded-xl bg-amber-50 dark:bg-amber-900/30 border border-amber-200/60 dark:border-amber-700/50 flex justify-center items-center flex-shrink-0">
            <img *ngIf="evCharger.logo" [src]="evCharger.logo" alt="Logo" class="w-6 h-6 object-contain" />
            <svg *ngIf="!evCharger.logo" xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-amber-500" fill="none"
              viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
          </div>

          <div class="min-w-0">
            <h2 class="text-sm font-bold text-slate-800 dark:text-slate-100 truncate">
              {{ evCharger.siteName || (currentLang === "TH" ? "สถานีชาร์จ" : "Charging Station") }}
            </h2>
            <div class="flex items-center gap-1.5 text-xs text-slate-500 dark:text-slate-400">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5 text-slate-400 flex-shrink-0" fill="none"
                viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path stroke-linecap="round" stroke-linejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <span class="truncate">{{ currentLang === "TH" ? "ช่องชาร์จ" : "Slot" }}: <span
                  class="font-semibold text-slate-700 dark:text-slate-300">{{ evCharger.spaceCode || "-"
                  }}</span></span>
            </div>
          </div>
        </div>

        <!-- Date Badge -->
        <span
          class="text-[11px] font-medium text-slate-500 dark:text-slate-400 bg-slate-100 dark:bg-slate-700/60 px-2.5 py-1 rounded-full flex-shrink-0">
          {{ evCharger.createDate || evCharger.chargingStart | date:'dd/MM/yyyy HH:mm' }}
        </span>
      </div>

      <!-- Card Content Info Grid -->
      <div class="grid grid-cols-2 gap-2 text-xs">

        <!-- License Plate -->
        <div class="flex items-center gap-1.5 text-slate-600 dark:text-slate-300">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-amber-500 flex-shrink-0" fill="none"
            viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z" />
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0" />
          </svg>
          <span
            class="font-semibold text-slate-800 dark:text-slate-200 bg-slate-100 dark:bg-slate-700 px-2 py-0.5 rounded-md">
            {{ evCharger.licensePlate || (currentLang === "TH" ? "ไม่ระบุทะเบียน" : "No License") }}
          </span>
        </div>

        <!-- Duration -->
        <div class="flex items-center gap-1.5 text-slate-600 dark:text-slate-300 justify-end">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-purple-500 flex-shrink-0" fill="none"
            viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span class="font-medium text-slate-700 dark:text-slate-300">
            {{ formatDuration(evCharger.totalTimeMinutes) }}
          </span>
        </div>

        <!-- Energy (kWh) -->
        <div class="flex items-center gap-1.5 text-slate-600 dark:text-slate-300">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-emerald-500 flex-shrink-0" fill="none"
            viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>
          <span>{{ currentLang === "TH" ? "พลังงาน" : "Energy" }}: <strong class="text-slate-800 dark:text-slate-200">{{
              evCharger.chargingKwh || 0 }} kWh</strong></span>
        </div>

        <!-- Time Range -->
        <div class="flex items-center gap-1.5 text-slate-500 dark:text-slate-400 justify-end">
          <span>
            {{ (evCharger.chargingStart | date:'HH:mm') || '-' }} - {{ (evCharger.chargingEnd | date:'HH:mm') || '-' }}
          </span>
        </div>

      </div>

      <!-- Card Footer: Total Price & Detail Action Button -->
      <div class="pt-2 border-t border-slate-100 dark:border-slate-700/40 flex items-center justify-between">
        <div class="text-xs">
          <span class="text-slate-400 dark:text-slate-400 mr-1">{{ currentLang === "TH" ? "ยอดชำระ:" : "Paid:" }}</span>
          <span class="text-base font-extrabold text-amber-600 dark:text-amber-400">
            ฿{{ evCharger.chargingAmount | number:'1.2-2' }}
          </span>
        </div>

        <button
          class="flex items-center gap-1 text-xs font-semibold text-amber-600 dark:text-amber-400 hover:text-amber-700 active:scale-95 transition-all">
          <span>{{ currentLang === "TH" ? "รายละเอียด" : "Details" }}</span>
          <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"
            stroke-width="2.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>

    </div>

    <!-- ================= Empty State Section ================= -->
    <div *ngIf="filteredEvChargerHistory.length === 0 && !isLoading"
      class="bg-white dark:bg-slate-800 rounded-3xl p-8 shadow-sm border border-slate-100 dark:border-slate-700 text-center space-y-3 animate-fade-in-up mt-6">

      <div
        class="w-16 h-16 bg-amber-100 dark:bg-amber-900/40 text-amber-500 rounded-full flex justify-center items-center mx-auto shadow-inner">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor"
          stroke-width="1.8">
          <path stroke-linecap="round" stroke-linejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      </div>

      <h3 class="text-base font-bold text-slate-800 dark:text-slate-100">
        {{ currentLang === "TH" ? "ไม่พบประวัติการชาร์จ" : "No Charging History Found" }}
      </h3>

      <p class="text-xs text-slate-500 dark:text-slate-400 max-w-xs mx-auto">
        {{ currentLang === "TH" ? "ยังไม่มีรายการชาร์จในระบบ หรือลองปรับเปลี่ยนคำค้นหา/ตัวกรองวัน" : "No history
        recorded yet, or try clearing search and filter criteria." }}
      </p>

      <button *ngIf="searchTerm || selectedFilter !== 'ALL'" (click)="clearSearch(); setFilter('ALL')"
        class="inline-flex items-center gap-1.5 px-4 py-2 bg-amber-400 hover:bg-amber-500 text-slate-900 text-xs font-semibold rounded-xl shadow-md active:scale-95 transition-all">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"
          stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
        </svg>
        <span>{{ currentLang === "TH" ? "ล้างตัวกรองทั้งหมด" : "Reset Filters" }}</span>
      </button>

    </div>

  </div>

</div>

<!-- ================= Detail Bottom Sheet Modal ================= -->
<div *ngIf="showDetailModal && selectedJobDetail" class="relative z-50">

  <!-- Backdrop Overlay -->
  <div (click)="closeDetail()" class="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-40 animate-fade-in-backdrop">
  </div>

  <!-- Bottom Sheet Container -->
  <div
    class="fixed bottom-0 inset-x-0 bg-white dark:bg-slate-800 rounded-t-[2.5rem] shadow-2xl p-6 z-50 max-h-[88vh] overflow-y-auto custom-scrollbar animate-slide-up-modal space-y-4">

    <!-- Top Handle Bar -->
    <div class="w-12 h-1.5 bg-slate-200 dark:bg-slate-700 rounded-full mx-auto -mt-2 mb-2"></div>

    <!-- Header Title & Close Button -->
    <div class="flex items-center justify-between border-b border-slate-100 dark:border-slate-700 pb-3">
      <div class="flex items-center gap-2">
        <div
          class="w-9 h-9 rounded-xl bg-amber-100 dark:bg-amber-900/40 text-amber-600 flex justify-center items-center">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"
            stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>
        </div>
        <div>
          <h3 class="text-base font-bold text-slate-800 dark:text-slate-100">
            {{ currentLang === "TH" ? "รายละเอียดการชาร์จ" : "Charging Details" }}
          </h3>
          <p class="text-xs text-slate-400">
            {{ selectedJobDetail.jobId ? ('ID: ' + selectedJobDetail.jobId) : (currentLang === "TH" ?
            "รายการชาร์จรถไฟฟ้า" : "EV Charge Record") }}
          </p>
        </div>
      </div>

      <button (click)="closeDetail()"
        class="w-8 h-8 rounded-full bg-slate-100 dark:bg-slate-700 text-slate-500 hover:text-slate-700 dark:text-slate-300 flex justify-center items-center active:scale-95 transition-transform"
        aria-label="Close modal">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"
          stroke-width="2.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Amount Summary Banner -->
    <div
      class="bg-gradient-to-r from-amber-500 to-amber-400 text-slate-900 rounded-2xl p-4 shadow-md text-center space-y-1">
      <p class="text-xs font-semibold text-slate-900/80">
        {{ currentLang === "TH" ? "ยอดชำระสุทธิ" : "Total Amount Paid" }}
      </p>
      <p class="text-2xl font-black">
        ฿{{ selectedJobDetail.chargingAmount | number:'1.2-2' }}
      </p>
    </div>

    <!-- Details Breakdown Grid -->
    <div class="bg-slate-50 dark:bg-slate-900/60 rounded-2xl p-4 space-y-3 text-xs">

      <!-- License Plate -->
      <div class="flex items-center justify-between border-b border-slate-200/60 dark:border-slate-700/60 pb-2">
        <span class="text-slate-500 dark:text-slate-400">{{ currentLang === "TH" ? "ทะเบียนรถ" : "License Plate"
          }}</span>
        <span
          class="font-bold text-slate-800 dark:text-slate-200 bg-white dark:bg-slate-800 px-2.5 py-1 rounded-lg shadow-xs">
          {{ selectedJobDetail.licensePlate || '-' }}
        </span>
      </div>

      <!-- Station Name -->
      <div class="flex items-center justify-between border-b border-slate-200/60 dark:border-slate-700/60 pb-2">
        <span class="text-slate-500 dark:text-slate-400">{{ currentLang === "TH" ? "สถานที่ / สถานี" : "Location /
          Station" }}</span>
        <span class="font-semibold text-slate-800 dark:text-slate-200 text-right">
          {{ selectedJobDetail.siteName || '-' }}
        </span>
      </div>

      <!-- Space Code -->
      <div class="flex items-center justify-between border-b border-slate-200/60 dark:border-slate-700/60 pb-2">
        <span class="text-slate-500 dark:text-slate-400">{{ currentLang === "TH" ? "ช่องชาร์จ" : "Charging Slot"
          }}</span>
        <span class="font-semibold text-amber-600 dark:text-amber-400">
          {{ selectedJobDetail.spaceCode || '-' }}
        </span>
      </div>

      <!-- Energy Charged -->
      <div class="flex items-center justify-between border-b border-slate-200/60 dark:border-slate-700/60 pb-2">
        <span class="text-slate-500 dark:text-slate-400">{{ currentLang === "TH" ? "พลังงานไฟฟ้า" : "Energy Consumption"
          }}</span>
        <span class="font-bold text-emerald-600 dark:text-emerald-400">
          {{ selectedJobDetail.chargingKwh || 0 }} kWh
        </span>
      </div>

      <!-- Total Duration -->
      <div class="flex items-center justify-between border-b border-slate-200/60 dark:border-slate-700/60 pb-2">
        <span class="text-slate-500 dark:text-slate-400">{{ currentLang === "TH" ? "ระยะเวลาชาร์จ" : "Charging Duration"
          }}</span>
        <span class="font-semibold text-slate-800 dark:text-slate-200">
          {{ formatDuration(selectedJobDetail.totalTimeMinutes) }}
        </span>
      </div>

      <!-- Start Time -->
      <div class="flex items-center justify-between border-b border-slate-200/60 dark:border-slate-700/60 pb-2">
        <span class="text-slate-500 dark:text-slate-400">{{ currentLang === "TH" ? "เริ่มชาร์จ" : "Started At" }}</span>
        <span class="font-medium text-slate-700 dark:text-slate-300">
          {{ selectedJobDetail.chargingStart | date:'dd/MM/yyyy HH:mm:ss' }}
        </span>
      </div>

      <!-- End Time -->
      <div class="flex items-center justify-between">
        <span class="text-slate-500 dark:text-slate-400">{{ currentLang === "TH" ? "สิ้นสุดการชาร์จ" : "Ended At"
          }}</span>
        <span class="font-medium text-slate-700 dark:text-slate-300">
          {{ selectedJobDetail.chargingEnd | date:'dd/MM/yyyy HH:mm:ss' }}
        </span>
      </div>

    </div>

    <!-- Modal Action Buttons -->
    <div class="pt-2">
      <button (click)="closeDetail()"
        class="w-full py-3 bg-amber-400 hover:bg-amber-500 text-slate-900 font-bold text-sm rounded-xl shadow-md active:scale-95 transition-all text-center">
        {{ currentLang === "TH" ? "ปิดหน้าต่าง" : "Close" }}
      </button>
    </div>

  </div>

</div>

<!-- CRITICAL: Loading Overlay element MUST be OUTSIDE the main wrapper container at the very bottom -->
<app-pss-loading *ngIf="isLoading"></app-pss-loading>